import {
  borderSkinParams,
  cornerSkinParams,
  generateSkinDefaults,
  withDefaultValues,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

const skinParams = {
  ...cornerSkinParams,
  ...borderSkinParams,
};

export const skinDefinition = withDefaultValues(skinParams);

export const skinDefinitionMap: Record<string, SkinDefinition> = {
  'wixui.skins.SocialPlayerYoutube': skinDefinition,
};

export default generateSkinDefaults(skinDefinitionMap);
